<template>
  <div :class="[bgColor, 'forget-pwd','login-new']">
    <p class="title">{{ $t("forget_password.nav_title") }}</p>
    <p class="sub-title">{{ $t('findPwd.t00002') }}</p>
    <div class="form">
      <div class="ipt-item">
        <custom-field
          v-model="form.id_card"
          :formatter="formatter"
          :placeholder="$t('open_account.idcard_verify.idcard_field.label')"
          clearable
        >
        </custom-field>
      </div>

      <div class="ipt-item">
        <custom-field
          v-model="form.email"
          :formatter="formatter"
          :placeholder="$t('forget_password.email_address')"
          clearable
        >
        </custom-field>
      </div>
      <div class="empty"></div>
      <div class="btn-submit mb0" :class="{dis: isDisabledSubmit}" @click="submit">{{ $t("common.confirm") }}</div>

    </div>
    <TelActions></TelActions>
  </div>
</template>

<script>
import customField from "@/components/customField/index.vue";
import TelActions from "./components/TelActions.vue";
import { Button, } from "vant";

export default {
  components: {
    [Button.name]: Button,
    customField: customField,
    TelActions
  },
  computed: {
    bgColor(){
      return this.$store.getters["common/bgColor"];
    },
    isDisabledSubmit() {
      return Object.keys({
        id_card: this.form.id_card,
        email: this.form.email
      }).some(key => {
        return !this.form[key];
      });
    }
  },
  data(){
    return {
      form: {
        id_card: '',
        email: ''
      },
    }
  },
  created(){
    this.sign = this.$route.query.sign;
  },
  methods:{
    formatter(value) {
      return value.replace(/ /g, "");
    },
    submit(){
      if(this.isDisabledSubmit){
        return;
      }
      const params = {
        sign: this.sign,
        email: this.form.email,
        id_card: this.form.id_card,
      };
      this.$apis.resetPassword2Api(params).then(res=>{
        if(res.user_no){
          this.$router.push({
            path: '/login-password-forget/step-third',
            query: {
              sign: this.sign,
              user_no: res.user_no
            }
          });
        }
      })
    }
  }
}
</script>


<style scoped lang="less">
@import "../login-new/components/form.comon.less";
</style>